import React from "react"
import { styled } from "@mui/material/styles"
import { countries } from "country-flag-icons"
// @ts-ignore
import Flags from "country-flag-icons/react/3x2"

import makeStyles from "@mui/styles/makeStyles"

import { CountryFlagProps } from "./CountryFlag.types"

import styles from "./CountryFlag.module.scss"

const PREFIX = "CountryFlag"

const classes = {
  flag: `${PREFIX}-flag`,
}

const Root = styled("span")(({ theme }) => ({
  [`& .${classes.flag}`]: {
    borderRadius: "4px",
    width: "32px",
    flexShrink: 0,
    margin: "2px 8px 2px 2px",
    border: `1px solid ${theme.palette.text.secondary}`,
  },
}))

const CountryFlag: React.FC<CountryFlagProps> = ({ code: codeProp }) => {
  const code = codeProp.toUpperCase()
  const legacyCodeMapping: { [key: string]: string } = {
    UK: "GB",
    XI: "GB",
  }
  const localeCountryMapping: { [key: string]: string } = {
    EN: "GB",
    DE: "DE",
    FR: "FR",
    DA: "DK",
    PL: "PL",
    NL: "NL",
  }

  const countryCode = legacyCodeMapping[code] || localeCountryMapping[code] || code
  const Flag: React.FC<{ className: string }> | null = countries.includes(countryCode)
    ? Flags[countryCode]
    : null

  return <Root>{Flag ? <Flag className={classes.flag} /> : null}</Root>
}

export default CountryFlag
